import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

const AppWrapper = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  // Temporarily disable StrictMode to fix OIDC callback double-processing
  // TODO: Re-enable StrictMode once react-oidc-context supports it better
  import.meta.env.DEV ? <AppWrapper /> : <React.StrictMode><AppWrapper /></React.StrictMode>
) 